import { useNavigate } from "react-router-dom";
import { PillButton } from "./PillButton";

export const HeroChat = () => {
  const navigate = useNavigate();
  return (
    <section className="relative overflow-hidden">
      <div className="container mx-auto px-3 lg:px-8 pt-4 sm:pt-6">
        <div className="relative mkt-gradient-hero mkt-grain rounded-[1.75rem] sm:rounded-[2rem] overflow-hidden px-5 sm:px-10 lg:px-16 py-14 sm:py-24 lg:py-36">
          {/* Soft light streaks */}
          <div className="absolute -right-32 top-10 w-[500px] h-[500px] rounded-full bg-white/10 blur-3xl pointer-events-none" />
          <div className="absolute -left-40 bottom-0 w-[400px] h-[400px] rounded-full bg-white/10 blur-3xl pointer-events-none" />

          <div className="relative max-w-3xl mx-auto text-center text-white">
            <h1 className="text-[32px] sm:text-6xl lg:text-7xl leading-[1.05] tracking-tight font-black">
              The anonymous feedback tool{" "}
              <span className="inline-block bg-white/95 text-[hsl(var(--mkt-primary-deep))] rounded-full px-3 sm:px-5 py-0.5 sm:py-1 align-middle whitespace-nowrap">
                HR actually trusts
              </span>
            </h1>
            <p className="mt-5 sm:mt-6 text-base sm:text-xl text-white/85 font-medium leading-relaxed">
              Finally get the honest truth about culture, retention, and morale — by simply chatting to your AI advisor. Setup in just 5 minutes.
            </p>

            <div className="mt-8 sm:mt-10 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-2.5 sm:gap-3">
              <PillButton variant="primary" size="lg" className="w-full sm:w-auto" onClick={() => navigate("/auth?mode=signup")}>
                Create anonymous page
              </PillButton>
              <PillButton variant="white" size="lg" className="w-full sm:w-auto" onClick={() => navigate("/contact")}>
                Book a demo
              </PillButton>
            </div>
            <div className="mt-5 grid grid-cols-2 sm:flex sm:flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-[11px] sm:text-xs text-white/75">
              <span>Free 15-day trial</span>
              <span className="hidden sm:inline" aria-hidden>·</span>
              <span>No credit card</span>
              <span className="hidden sm:inline" aria-hidden>·</span>
              <span>GDPR compliant</span>
              <span className="hidden sm:inline" aria-hidden>·</span>
              <span>Live in 5 minutes</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
